<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <ng-container formArrayName="supportRepartition">
              @if (hasNonStructuredSupports) {
                <supports-table
                  [supports]="supportRepartition"
                  [config]="nonStructuredTable"
                ></supports-table>
              }
              @if (hasStructuredSupports) {
                <supports-table
                  [supports]="supportRepartition"
                  [config]="structuredTable"
                ></supports-table>
              }
              @if (emptyRatesWarning) {
                <pr-color-panel [display]="emptyRatesWarning.display">
                  <pr-panel-body clazz="pam">
                    <pr-label
                      [name]="emptyRatesWarning.icon"
                      [width]="18"
                      [height]="18"
                      >{{ emptyRatesWarning.text }}</pr-label
                    >
                  </pr-panel-body>
                </pr-color-panel>
              }
            </ng-container>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
